// https://github.com/dcastil/tailwind-merge/blob/v2.0.0/docs/features.md
import { twJoin as tj, extendTailwindMerge } from 'tailwind-merge';
import twTheme from '../theme';

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': Object.keys(twTheme.fontSize).map(key => `text-${key}`),
    },
  },
});

export const twJoin = tj;
